import { createAction, makeActionTrackable } from '@lingoda/core';
import type { Currency } from '@lingoda/currency';

export type DeletePaymentContractPayload = {
    paymentMethodId: string;
    currency: Currency;
};

export default makeActionTrackable(
    createAction<DeletePaymentContractPayload>('payment/DELETE_PAYMENT_CONTRACT'),
);
